import React, { Component } from 'react'
import Unsplash from './unsplash'
import debounce from 'lodash/debounce'
import { apiUnsplashSearch } from '../../../common/api/lesson'
import { errorHandler } from 'pobble-components/dist/error-handler'

class UnsplashContainer extends Component {
  state = { previews: [], request: { pending: false, error: null } }
  componentDidMount() {
    const { defaultSearchValue } = this.props
    defaultSearchValue && this.onSearchChange(defaultSearchValue)
  }
  onSearchChange = value => {
    this.search(value)
  }
  search(value) {
    this.setState({ request: { pending: true, error: false } })
    apiUnsplashSearch({ search_term: value, per_page: 12, page: 1 })
      .then(res =>
        this.setState({
          previews: res.data,
          request: { pending: false, error: null }
        })
      )
      .catch(e => {
        this.setState({ request: { pending: false, error: e } })
        throw e
      })
      .catch(errorHandler)
  }
  render() {
    const { defaultSearchValue, onUnsplashSelect, pending } = this.props
    const { previews, request } = this.state
    return (
      <Unsplash
        onUnsplashSelect={onUnsplashSelect}
        pending={request.pending || pending}
        previews={previews}
        defaultSearchValue={defaultSearchValue}
        onSearchChange={debounce(this.onSearchChange, 300)}
      />
    )
  }
}

export default UnsplashContainer
